import { useEffect } from "react";
import { useSelector } from "react-redux";
import { connectSocket, disconnectSocket } from "services/socket";

function SocketProvider({ children }) {
//   const profile = useSelector(state => state.auth.profile);
//   const token = useSelector(state => state.auth.token);

  useEffect(() => {
    // if (profile && token) {
    //   connectSocket(token);
    // } else {
    //   disconnectSocket();
    // }
    connectSocket()

    return () => {
      disconnectSocket();
    };
  }, []);

  return children;
}

export default SocketProvider;